import { onErrorShowMessage } from '~src/errors';
import { PageImageError } from '~src/multipages/currentPageImage';

// Senza l'immagine aggiornata della pagina aperta l'esportazione si ferma:
// meglio un errore chiaro che un file con la pagina com'era prima.
export const handlePageImageError = (error) => {
  if (!(error instanceof PageImageError)) {
    throw error;
  }

  console.error(error);
  return onErrorShowMessage(false, {
    title: 'Esportazione non riuscita',
    text:
      "Non è stato possibile preparare l'immagine della pagina aperta. Salva il progetto, ricarica l'editor e riprova.",
  });
};
